export default "__VITE_ASSET__daf0f602__"